export const getMethodColor = (
  method: string,
): "success" | "info" | "warning" | "danger" | "neutral" => {
  switch (method.toUpperCase()) {
    case "GET":
      return "success";
    case "POST":
      return "info";
    case "PUT":
      return "warning";
    case "PATCH":
      return "warning";
    case "DELETE":
      return "danger";
    default:
      return "neutral";
  }
};
